module.exports = {
  footerText: 'Copyright Phillips Outsourcing © 2020',
}
